const baseURL = process.env.REACT_APP_API_URL || "";
const endpoint = "chats";

export const addChat = async (payload) => {
  if (!baseURL) throw new Error();

  const res = await fetch(`${baseURL}/${endpoint}`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify(payload),
  });

  return res.json();
};

// We can only show today's messages
export const getChatMessages = async (userId) => {
  const res = await fetch(`${baseURL}/${endpoint}/${userId}`);
  return res.json();
};

export const updateReaction = async (messageId, isLiked) => {
  if (!baseURL) throw new Error();

  const res = await fetch(`${baseURL}/${endpoint}/${messageId}`, {
    method: "PATCH",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify({
      isLiked,
    }),
  });

  return res.json();
};
